// extracted by mini-css-extract-plugin
export default {"pay-component":"C2ZMz_pay-component"};